import React from 'react';
import { Outlet } from 'react-router-dom';

type Props = {};

const ManPowerManagementPageLayout = (props: Props) => {
    return (
        <><Outlet /></>
    );
};

export default ManPowerManagementPageLayout;
